import { ApplicationState } from '../../ApplicationState'

export const FETCH_TRACE = 'V2/Trace/Fetch'
export const WRITE_SHARED_INFO = 'V2/Trace/Shared/FetchInfo'
export const WRITE_SHARED_COMPARISON_INFO = 'V2/Trace/Shared/FetchComparisonInfo'
export const FETCH_TRACE_HISTORY = 'V2/Trace/Summary/FetchHistory'

export const fetchTrace = (id: string) => ({
    type: FETCH_TRACE,
    payload: ({ fetchForApplication, getState }) => {
        const state: ApplicationState = getState()

        return fetchForApplication(`/trace/${id}/data/raw`).then(data => ({
            data,
        }))
    },
})

export interface ShareTraceParams {
    id: string
    shareDuration: number
}

export interface ShareTraceComparisonParams {
    id: string
    baseId: string
    shareDuration: number
}

export const shareTrace = ({ id, shareDuration }: ShareTraceParams) => ({
    type: WRITE_SHARED_INFO,
    payload: ({ fetchForApplication }) => fetchForApplication(`/trace/${id}/share/${shareDuration}`, { method: 'POST' }),
})

export const shareTraceComparison = ({ id, baseId, shareDuration }: ShareTraceComparisonParams) => ({
    type: WRITE_SHARED_COMPARISON_INFO,
    payload: ({ fetchForApplication }) => fetchForApplication(`/trace/${id}/compare/${baseId}/share/${shareDuration}`, { method: 'POST' }),
})

export interface FetchTraceHistoryParameters {
    environment: string
    service: string
}

export const fetchTraceHistory = ({ environment, service }: FetchTraceHistoryParameters) => ({
    type: FETCH_TRACE_HISTORY,
    payload: ({ fetchForApplication }) => fetchForApplication(`/traces/historyData?env=${environment}&s=${service}`),
})
